import { render, staticRenderFns } from "./searchAndQueryOfPropertyKnowledgeBaseList.vue?vue&type=template&id=39991702&"
import script from "./searchAndQueryOfPropertyKnowledgeBaseList.vue?vue&type=script&lang=js&"
export * from "./searchAndQueryOfPropertyKnowledgeBaseList.vue?vue&type=script&lang=js&"
import style0 from "./searchAndQueryOfPropertyKnowledgeBaseList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports